<template>
  <div>
    <ServerCreate/>

    <table class="table table-striped table-sm">
      <thead>
      <tr>
        <th scope="col"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(row, index) in servers"
          :key="index"
      >
        <td>{{row.name}}</td>
        <td>
          <router-link :to="{name: 'server', params: { id: row.id }}">Перейти</router-link>
        </td>
      </tr>
      </tbody>
    </table>

  </div>

</template>

<script setup>
import {computed} from "vue";

import {useServersStore} from '@/store/servers'
import ServerCreate from "@/components/servers/ServerCreate";
const serversStore = useServersStore()


// server list
const servers = computed(() => serversStore.items)
serversStore.getList()
</script>
